// WINESS CUSTOM: Warm (decode) product gallery images just-in-time so the
// cross-fade in section-winess-gallery-fade.css never flashes white.
//
// Craft lazy-loads non-active gallery images, so switching to one shows the
// white container until it downloads/decodes. Here we eagerly load + decode a
// target image the moment the user signals intent (hovering / pressing a
// thumbnail, or pressing a slider arrow), plus the neighbours of the active
// slide on load. This keeps the page's initial load lazy (good for LCP) while
// making switches paint instantly.

(function () {
  if (window.WinessGalleryFade) return;
  window.WinessGalleryFade = true;

  function warm(img) {
    if (!img || img.dataset.winessWarm) return;
    img.dataset.winessWarm = '1';
    if (img.getAttribute('loading') === 'lazy') img.setAttribute('loading', 'eager');
    // decode() forces the browser to fetch + decode now; ignore failures
    // (e.g. not yet in the DOM / unsupported) — the eager load still helps.
    if (typeof img.decode === 'function') img.decode().catch(function () {});
  }

  function initGallery(gallery) {
    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return;
    // Select the media-item wrappers only — NOT every [data-media-id], which also
    // matches the inner zoom-toggle buttons and would corrupt neighbour indexing.
    var items = Array.prototype.slice.call(viewer.querySelectorAll('.product__media-item'));
    if (items.length < 2) return;

    var imgById = {};
    items.forEach(function (item) {
      imgById[item.dataset.mediaId] = item.querySelector('.product__media img');
    });

    var warmItem = function (item) {
      if (item) warm(item.querySelector('.product__media img'));
    };
    var indexOfActive = function () {
      for (var i = 0; i < items.length; i++) {
        if (items[i].classList.contains('is-active')) return i;
      }
      return 0;
    };
    var warmNeighbours = function () {
      var i = indexOfActive();
      warmItem(items[i - 1]);
      warmItem(items[i + 1]);
    };

    // Warm the target as soon as a thumbnail is hovered or pressed.
    var thumbnails = gallery.querySelector('[id^="GalleryThumbnails"]');
    if (thumbnails) {
      thumbnails.querySelectorAll('[data-target]').forEach(function (thumb) {
        var trigger = function () {
          warm(imgById[thumb.dataset.target]);
        };
        thumb.addEventListener('pointerenter', trigger);
        thumb.addEventListener('pointerdown', trigger);
      });
    }

    // Warm the neighbours of the current slide when a prev/next arrow is pressed.
    viewer.querySelectorAll('.slider-button').forEach(function (btn) {
      btn.addEventListener('pointerdown', warmNeighbours);
    });

    // Warm the immediate neighbours of the active slide on load so the first
    // arrow click is instant.
    warmNeighbours();
  }

  var start = function () {
    document.querySelectorAll('media-gallery').forEach(initGallery);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
